// extracted by mini-css-extract-plugin
export var dividerLine = "_8n-3";
export var itemImage = "_8n-9";
export var lightDivider = "_8n-4";
export var modalContent = "_8n-5";
export var modalContentCompact = "_8n-6";
export var productCard = "_8n-a";
export var productImage = "_8n-b";
export var productImageCompact = "_8n-7";
export var productImagePlaceholder = "_8n-c";
export var productImagePlaceholderCompact = "_8n-8";
export var progressBarBackground = "_8n-1";
export var progressBarContainer = "_8n-0";
export var progressBarFill = "_8n-2";